import type { CSSProperties } from 'react';

interface LogoProps {
  size?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
}

export function Logo({ size = 48, color = 'currentColor', className, style }: LogoProps) {
  return (
    <svg
      viewBox="0 0 143.8 143.8"
      // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- this is an inline vector graphic (multiple <path> elements), not a raster image; role="img" + aria-label is the standard accessible pattern for inline SVGs, there is no native <img> equivalent
      role="img"
      aria-label="DeadDrop logo"
      className={className}
      style={{ width: size, height: size, fill: color, ...style }}
    >
      <path d="M69.3,83.4l-46.3,33.2c-2.8,2-1.2,5.9,2.4,5.9h93.1c3.5,0,5.1-3.9,2.3-5.9l-46.4-33.3c-1.5-1.1-3.6-1.1-5.1,0Z" />
      <path d="M126.6,110l-36-25.7c-1.6-1.2-1.5-3.4.3-4.4l34.8-18.6c2.9-1.5,6.6.3,6.6,3.3v42.9c0,2.6-3.4,4-5.6,2.4Z" />
      <path d="M18,47.3l51.9-32c1.3-.8,2.9-.8,4.2,0l51.6,31.8c3.1,1.9,2.9,6.8-.3,8.4l-2.3,1.2c-1.3.7-2.8.6-4-.2l-45-28.2c-1.3-.8-2.9-.8-4.3,0l-45.9,28.2c-1.3.8-2.8.8-4.1,0l-1.8-1c-3.1-1.7-3.2-6.5-.1-8.4Z" />
      <path d="M45.2,60.8l24.7,13.3c1.2.8,2.7.8,3.9,0l25.1-13.3c2.4-1.6,2.5-5.5.1-7.2l-.6-.4c-1.2-.9-2.7-.9-4,0l-21.4,10.9c-.6.4-1.4.4-2.1,0l-21.2-10.9c-1.2-.8-2.7-.8-3.9,0l-.7.5c-2.4,1.7-2.3,5.6,0,7.1Z" />
      <path d="M70.3,39.8h3.3c2.2,0,3.9,1.9,3.9,4.2v21.3c0,.9-.5,1.7-1.2,2l-3.6,1.6c-.5.2-1.1.2-1.6,0l-3.7-1.7c-.8-.3-1.2-1.1-1.2-2v-21.1c0-2.4,1.8-4.4,4.1-4.4Z" />
      <path d="M18.1,61.5l33.5,18c2.5,1.3,2.7,4.4.4,6l-34,24c-2.6,1.9-6.5.2-6.5-2.8l.2-42.1c0-2.9,3.6-4.7,6.4-3.2Z" />
    </svg>
  );
}
